<template>
  <div class="main">
    <base-card v-for="pizza in pizzas" :key="pizza.name">
      <v-card-title>{{ pizza.name }}</v-card-title>
      <v-card-text>{{ pizza.text }}</v-card-text>
      <v-card-actions class="flex text-right"
        ><v-spacer></v-spacer>{{ pizza.price }}</v-card-actions
      >
    </base-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pizzas: [
        {
          name: "Капричиоза",
          text: "Пилешки гради, млечен кашкавал, свежи печурки",
          price: "100 ден.",
        },
        {
          name: "Маргарита",
          text: "Млечен кашкавал, доматен сос",
          price: "100 ден.",
        },
        {
          name: "Пеперони-кулен",
          text: "Млечен кашкавал, кулен, доматен сос",
          price: "130 ден.",
        },
      ],
    };
  },
};
</script>

<style scoped>
.main {
  min-height: 100vh;
  background: transparent;
}
</style>
